export const Button = 'atlantis-button';